document.addEventListener("DOMContentLoaded", function () {

  const listing = document.querySelector('.speakersListing');

  if (listing) {
    const btn = document.getElementById("loadmore-btn");
    let currentPage = 1;

    // Load more functionality
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const postType = btn.dataset.type;
        showNextItems(btn, postType);
      });
    }

    function showNextItems(button, postType) {
      button.classList.add("loading");

      let maxNumPages = button.dataset.maxNumPages;
      let event = button.dataset.event;
      currentPage++

      let data = {
        'action': 'loadmore_' + postType,
        'query': loadmore_params.posts,
        'page': currentPage,
        'security': loadmore_params.security,
        'max_num_pages': maxNumPages,
        'post_type': postType,
        'paged': currentPage,
        'event': event
      };

      fetch(loadmore_params.ajaxurl, {
        method: 'POST',
        body: new URLSearchParams(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => response.text())
        .then(data => {
          if (data) {
            button.firstElementChild.textContent = 'Load More';
            loadmore_params.current_page++;

            let listingLoadSpeakers = document.querySelector('.speakersListing__grid');
            listingLoadSpeakers.insertAdjacentHTML('beforeend', data);

            if (loadmore_params.current_page == maxNumPages) {
              button.remove();
            } else {
              button.classList.remove("loading");
            }
          } else {
            button.remove();
          }
        })
        .catch(error => {
          button.firstElementChild.textContent = 'Load More';
          console.error(error);
        });
    }
  }

});
